import React from "react"
import "./CostsAssociatedBox.scss"

const CostsAssociatedBox = () => {
  return (
    <div className="costs-associated-box">
      <p className="costs-associated-title">
        Costs Associated with Your Purchase
      </p>
      <p className="costs-associated-value">
        In addition to the purchase price and ongoing charges associated with
        the property, there are other costs you should be aware of:
      </p>
      <ul className="costs-list">
        <li>Legal fees and disbursements</li>
        <li>Mortgage-related costs</li>
        <li>Stamp Duty Land Tax</li>
      </ul>
      <p className="costs-associated-value">
        We recommend you obtain quotes from a solicitor and speak with a lender
        or mortgage advisor to fully understand these costs. You can also
        calculate any potential SDLT liability using the UK government's
        official calculator.
      </p>
    </div>
  )
}

export default CostsAssociatedBox
